import { render, staticRenderFns } from "./zhike.vue?vue&type=template&id=1f9c7524&scoped=true&"
import script from "./zhike.vue?vue&type=script&lang=js&"
export * from "./zhike.vue?vue&type=script&lang=js&"
import style0 from "./zhike.vue?vue&type=style&index=0&id=1f9c7524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c7524",
  null
  
)

export default component.exports